// extracted by mini-css-extract-plugin
export default {"menu_wrapper":"Menu_menu_wrapper__zOtxb","menu_active":"Menu_menu_active__9btL3","menu_inner":"Menu_menu_inner__a09v7","darker":"Menu_darker__eSOzB"};